export const errorDataSummaryModalTranslationJP = {
  ErrorDataSummaryModal: {
    head_title: 'エラー',
    error_detail: 'エラー詳細',
    restaurant_cd: '店舗コード',
    restaurant_name: '店舗名',

    not_found_invalid_data: '店舗情報の異常はありません。',

    warn_error_pattern1: 'メニューに割り当てられていないレジ情報が複数存在します。',
    warn_error_pattern2: 'MS_MST_MLU.csvとTMS_MST_MENUCONST.csvの両方に存在するPOSコードが存在します。',
    warn_error_pattern3or4: '一つのメニューに表示すべきPOSコードが複数存在します。',
    warn_error_pattern5:
      '一つのPOSコードがメニューとサブタイトルメニューに存在します。メニューを削除するか食材管理システムの登録を変更してください。',

    warn_has_invalid_consistency: '販売タイプとレジパターンの整合性チェックで異常が有るので、確認してください',
    delivery_submit: '配信を続行',
  },
};
